import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { PropertySchema } from '../../properties/response/PropertyBaseSchema';

const RoomTypeSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
});

const RatePlanSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
});

const DynamicPricingRuleSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    group_id: z.string().uuid(),
    start: z.number().int(),
    end: z.number().int(),
    adjustment_percentage: z.coerce.number(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

const DynamicPricingPeriodSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    group_id: z.string().uuid(),
    start_date: z.string(),
    end_date: z.string(),
    days: z.string(),
    // DIUBAH: Definisikan tipe secara spesifik agar cocok dengan komponen child
    type: z.enum(['include', 'exclude']),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

const DynamicPricingItemSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    group_id: z.string().uuid(),
    room_type_id: z.string().uuid(),
    rate_plan_id: z.string().uuid(),
    min_rate_override: z.coerce.number().nullable(),
    max_rate_override: z.coerce.number().nullable(),
    is_min_stay_restriction: z.boolean(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    room_type: RoomTypeSchema,
    rate_plan: RatePlanSchema,
});

export const DynamicPricingGroupSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    calculation_method: z.string(),
    last_minute_restriction: z.boolean(),
    last_minute_days: z.number().int(),
    min_stay_restriction: z.boolean(),
    min_stay_nights: z.number().int(),
    is_active: z.boolean(),
    last_executed_at: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    items: z.array(DynamicPricingItemSchema).optional(),
    rules: z.array(DynamicPricingRuleSchema).optional(),
    periods: z.array(DynamicPricingPeriodSchema).optional(),
    property: z.lazy(() => PropertySchema.optional()),
});

export const DynamicPricingGroupResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(DynamicPricingGroupSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type DynamicPricingGroupResponse = z.infer<typeof DynamicPricingGroupResponseSchema>;
export type DynamicPricingGroupData = z.infer<typeof DynamicPricingGroupSchema>;